import { Button, ModalContent } from '@sandtech-hub-monorepo/ui-kit';
import { BulbIcon } from '@sandtech-hub-monorepo/ui-kit-site';
import { Link } from 'react-router-dom';
import { ReactComponent as DocuSignIcon } from '../../../../assets/Icons/docusign-icon.svg';

interface EnrollmentAgreementModalProps {
  docusignLink: string | undefined | null;
  close: () => void;
}

export const EnrollmentAgreementModal = ({
  docusignLink,
  close,
}: EnrollmentAgreementModalProps) => {
  return (
    <ModalContent>
      <div className="flex flex-col items-center text-center gap-6 max-w-[470px] mx-auto">
        <div className="flex flex-col gap-4 items-center">
          <h2 className="text-primary font-semibold text-2xl">
            Sign Enrollment Agreement
          </h2>
          <div className="text-foreground text-base">
            To continue with your application process, you'll need to{' '}
            <strong>sign your enrollment agreement</strong>.
          </div>
        </div>

        {/* DocuSign Logo */}
        <div className="flex justify-center my-6">
          <DocuSignIcon className="w-[200px] h-auto" />
        </div>

        <div className="bg-background-quaternary flex gap-4 items-center px-6 py-4 rounded-lg w-full">
          <div className="bg-background rounded-full p-3 text-primary shrink-0">
            <BulbIcon />
          </div>
          <div className="text-foreground text-sm text-left">
            This will open a secure page on our partner service{' '}
            <strong>DocuSign</strong>. You'll be redirected outside this app to
            complete this step.
          </div>
        </div>

        <div className="flex justify-center">
          <Link to={docusignLink || '#'} target="_blank">
            <Button onClick={close}>Take me to DocuSign</Button>
          </Link>
        </div>
      </div>
    </ModalContent>
  );
};
